export const curriculumDetailList = [
  {
    step: '1-4주차',
    title: 'Python 프로그래밍 기초',
    descList: [
      'Python 문법과 객체지향 프로그래밍 필수 개념 이해',
      '실습 문제 풀이 및 프로젝트 기반 학습으로 문제 해결 능력 배양',
      'ChatGPT 및 Copilot 적극 활용으로 오류 해결 및 코드 최적화, 생산성 향상',
      '실무 예제 및 프로젝트를 통한 실전 감각 배양',
    ],
    contents: [
      {
        contentsInnerTitle: '개발 환경 설정 및 기본 문법 익히기',
        contentsInnerDesc: [
          'VSCode 설치 및 가상 환경(venv) 설정',
          '기본 명령어 및 터미널 활용',
          '자료형(int, float, str, bool) 및 컬렉션(list, tuple, dict, set) 이해',
        ],
      },
      {
        contentsInnerTitle: '조건문과 반복문으로 로직 구현 능력 배양',
        contentsInnerDesc: [
          '조건문 (if, elif, else) 및 반복문 (for, while)',
          'List Comprehension 및 Dictionary Comprehension 활용',
        ],
      },
      {
        contentsInnerTitle: '데이터 구조와 파일 입출력으로 데이터 처리 역량 강화',
        contentsInnerDesc: [
          '리스트, 튜플, 딕셔너리 등의 자료구조 이해 및 활용',
          '파일 입출력 (open, read, write) 및 JSON 데이터 처리',
        ],
      },
      {
        contentsInnerTitle: '모듈화 및 객체지향 프로그래밍(OOP) 설계 능력 개발',
        contentsInnerDesc: [
          '모듈과 패키지 사용법 (import, from, as)',
          '클래스와 객체 개념, 생성자 및 소멸자 활용',
          '상속 (단일 상속, 다중 상속)으로 코드 재사용성 강화',
        ],
      },
      {
        contentsInnerTitle: 'Git 협업 도구 활용 및 실무 적용 능력 향상',
        contentsInnerDesc: ['Git 기본 개념 및 GitHub 협업', 'Branch, Merge, Pull Request 실습'],
      },
      {
        contentsInnerTitle: 'AI IDE 기반의 문제 해결 및 코드 최적화',
        contentsInnerDesc: [
          'AI 도구를 통한 코드 리뷰 및 디버깅',
          'ChatGPT, Copilot, Cursor 등의 AI 활용으로 생산성 및 코드 품질 향상',
        ],
      },
    ],
  },
  {
    step: '5-10주차',
    title: 'Django 기초 및 데이터베이스',
    descList: [
      'MTV 패턴, ORM 개념, 관계형 데이터 모델을 이론과 실습을 통해 완벽히 이해',
      'Django 프로젝트 실습을 통해 실무 능력 배양',
      'ChatGPT, Copilot, Cursor 등 AI IDE 기반 오류 해결 및 코드 최적화, 생산성 향상',
      '실제 웹 애플리케이션을 통해 Django와 데이터베이스 연동 실습',
    ],
    contents: [
      {
        contentsInnerTitle: 'Django 구조 및 MTV 패턴 이해',
        contentsInnerDesc: [
          'Django의 기본 개념 및 프로젝트 구조 학습',
          'MTV (Model-Template-View) 패턴 이해 및 URL Routing 설계',
          'Template 언어를 활용한 동적 웹 페이지 생성',
        ],
      },
      {
        contentsInnerTitle: 'Model 설계 및 ORM 활용',
        contentsInnerDesc: [
          'Django ORM (Object-Relational Mapping) 기본 개념 이해',
          'QuerySet을 사용한 데이터 조작 (CRUD) 및 필터링',
          '효율적인 데이터 관리와 설계 능력 배양',
        ],
      },
      {
        contentsInnerTitle: '관계형 데이터 모델(RDBMS) 및 ERD 모델링',
        contentsInnerDesc: [
          'PK(Primary Key), FK(Foreign Key), 테이블 간 관계 이해 (1:1, 1:N, N:M)',
          'ERD(Entity-Relationship Diagram) 작성 및 데이터 모델링 실습',
          '정규화(Normalization) 및 데이터 무결성 유지',
        ],
      },
      {
        contentsInnerTitle: 'SQL 기본 문법 및 PostgreSQL 실습',
        contentsInnerDesc: [
          'SQL 기본 문법 (SELECT, INSERT, UPDATE, DELETE)',
          'JOIN (INNER JOIN, LEFT JOIN, RIGHT JOIN, FULL OUTER JOIN) 활용',
          'PostgreSQL 설치 및 DBeaver를 통한 데이터 관리 및 시각화',
        ],
      },
      {
        contentsInnerTitle: 'Django와 PostgreSQL 연동 및 실습',
        contentsInnerDesc: [
          'Django Model → PostgreSQL 테이블 연결 및 Migrate',
          'ORM을 통한 데이터 CRUD 및 QuerySet 활용',
          'Form 및 Validation 처리로 사용자 입력 검증 및 보안 강화',
        ],
      },
    ],
  },
  {
    step: '11-18주차',
    title: 'Django 심화와 AWS 배포 및 \nAI IDE 활용',
    descList: [
      '사용자 인증, 관리자 페이지 커스터마이징, RESTful API 설계',
      'DevOps 역량 강화로 Docker 및 AWS를 활용한 배포 및 운영 자동화 실습',
      '코드 최적화 및 에러 해결, 생산성 향상',
      '실전 이커머스 웹사이트 구축 및 배포 경험',
    ],
    contents: [
      {
        contentsInnerTitle: 'Django REST Framework (DRF)를 활용한 RESTful API 설계 및 구현',
        contentsInnerDesc: [
          'DRF를 사용한 API 설계 및 CRUD 구현',
          'Serializer, Viewset, Router 활용한 모듈화된 API 설계',
          'Swagger/Postman을 활용한 API 문서화 및 테스트',
        ],
      },
      {
        contentsInnerTitle: '고성능 비동기 API 개발',
        contentsInnerDesc: [
          'FastAPI를 활용한 비동기 API 설계 및 구현',
          '비동기 요청 처리 및 성능 최적화',
        ],
      },
      {
        contentsInnerTitle: '서버 운영 및 배포 환경 구축',
        contentsInnerDesc: [
          'Linux 기초 명령어와 서버 관리 능력 배양',
          'Docker를 이용한 애플리케이션 컨테이너화 및 배포 자동화',
          'Docker Compose를 통한 Django + PostgreSQL 컨테이너 연동',
        ],
      },
      {
        contentsInnerTitle: 'AWS 클라우드 배포 및 운영 자동화',
        contentsInnerDesc: [
          'AWS EC2 인스턴스 생성 및 배포 환경 설정',
          'AWS RDS(PostgreSQL) 연결 및 데이터 관리',
          'S3, CloudFront를 활용한 정적 파일 호스팅 및 CDN 설정',
        ],
      },
      {
        contentsInnerTitle: 'CI/CD 파이프라인 구축',
        contentsInnerDesc: [
          'GitHub Actions 및 Docker를 활용한 CI/CD 파이프라인 구현',
          '자동화된 배포 및 테스트 환경 구축',
        ],
      },
      {
        contentsInnerTitle: '고급 웹 서비스 및 오픈 API 연동',
        contentsInnerDesc: [
          'OPEN API를 활용한 외부 서비스 연동 및 고도화',
          'OAuth 인증을 통한 소셜 로그인 및 사용자 인증 구현',
        ],
      },
      {
        contentsInnerTitle: 'Docker, Django 기반 백엔드 중심의 AI IDE 활용',
        contentsInnerDesc: [
          'AI 기반 웹 애플리케이션 개발 (Django + AI 활용)',
          'AI 기반 추천 시스템 개발 (Django + OpenAI API 활용)',
          'AI 챗봇 연동 (LangChain, LlamaIndex 활용)',
          'AI 기반 로그 분석 및 이상 탐지 (AI Ops, Elastic Stack)',
          'AI 기반 데이터 자동 분류 및 태깅 (Scikit-learn, NLP 활용)',
          'AI 기반 API 설계 및 성능 최적화 (FastAPI 연동)',
        ],
      },
    ],
  },
  {
    step: '18-24주차',
    title: '백엔드 아키텍처 설계 및 \nAI 활용 서비스 구축',
    descList: [
      'CBV(Class-Based View), Mixin, Signal 활용',
      'GitHub Actions를 통한 자동화 배포',
      '보안 및 성능 최적화의 HTTPS 설정, CORS, 성능 튜닝',
      '고도화된 아키텍처 설계 및 배포 실습',
      'AI를 활용한 자동화 및 개인/팀 프로세스 실습',
    ],
    contents: [
      {
        contentsInnerTitle: 'GitHub Actions를 이용한 CI/CD 파이프라인 구축',
        contentsInnerDesc: [
          'CI/CD 자동화 및 GitHub Actions 실습',
          'Docker 이미지를 활용한 자동화 배포 및 테스트',
        ],
      },
      {
        contentsInnerTitle: '고급 Django 아키텍처 패턴 설계',
        contentsInnerDesc: [
          'CBV(Class-Based View), Mixin, Signal 활용한 모듈화',
          '코드 재사용성 및 유지보수성 향상',
        ],
      },
      {
        contentsInnerTitle: 'Nginx 및 Gunicorn을 활용한 배포 최적화',
        contentsInnerDesc: [
          'Nginx 설치 및 Reverse Proxy 설정',
          'Gunicorn + Nginx 구조 설계 및 배포 실습',
          '로드 밸런싱 및 캐시 설정',
        ],
      },
      {
        contentsInnerTitle: '보안 및 성능 최적화',
        contentsInnerDesc: ['SSL 인증서 적용 및 HTTPS 설정', 'CORS 설정 및 데이터베이스 성능 튜닝'],
      },
      {
        contentsInnerTitle: '클라우드 서비스 및 마이크로서비스 아키텍처 설계',
        contentsInnerDesc: [
          '다양한 기술 결합 및 서버리스 환경 이해',
          '클라우드 네이티브 설계 및 인프라 자동화',
        ],
      },
      {
        contentsInnerTitle: '프로젝트 기반 학습 및 실무 적용 강화',
        contentsInnerDesc: [
          '실무 예제 및 프로젝트를 통한 실전 감각 배양',
          '고도화된 아키텍처 설계 및 배포 실습',
        ],
      },
      {
        contentsInnerTitle: 'AI 자동화 및 프로젝트 실습',
        contentsInnerDesc: [
          'AI를 활용한 테스트 자동화 (Selenium + AI)',
          'Django ORM 성능 최적화 및 AI 기반 쿼리 개선',
          'AI 기반 DevOps 및 백엔드 자동화 (Docker 활용)',
          'Docker 환경에서 AI 모델 배포 및 연동',
          'Docker Compose를 활용한 Django + AI 서비스 구축',
          'Elastic Stack을 활용한 성능 모니터링 및 이상 탐지',
          'Django 기반 AI 서비스 개발 및 배포',
          '개별/ 팀별 프로젝트 진행 및 Django + AI + Docker 기반 서비스 배포 코드 리뷰 및 발표',
        ],
      },
    ],
  },
]

export const projectTypeList = [
  {
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section5_project1_m.gif',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section5_project1_pc.gif',
    type: '프로젝트 1',
    title: '부동산 거래 웹사이트 구축 프로젝트',
    descList: [
      'Celery → 실시간 시세 분석 백그라운드 작업 처리 (크롤링, DB 업데이트 등)',
      '스케줄링 → 하루 단위 부동산 트렌드 리포트 자동 생성',
      '채팅 서비스 → 중개인-고객 실시간 문의 WebSocket 구현',
      '생성형 AI → 매물 설명 자동 생성, FAQ 챗봇 개발',
    ],
    noti: '*실제 부동산협회 대상으로 진행된 기업 프로젝트',
    descList2: [
      '실시간 데이터 연동 능력부터 AI 활용 경험까지 현직 백엔드 개발자들이 선호하는 핵심 역량을 실제 기업 프로젝트 기반으로 어필할 수 있어요.',
      '실무에서 핵심이 되는 기업의 관점이 아닌 유저 맞춤형 콘텐츠의 자동화를 직접 배우고 개발한 경험을 어필하여 즉시 실무 투입이 가능한 수준의 업무 역량을 어필할 수 있어요.',
    ],
  },
  {
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section5_project2_m.gif',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section5_project2_pc.gif',
    type: '프로젝트 2',
    title: '쇼핑몰 플랫폼 개발',
    descList: [
      '결제 서비스 → Stripe/카카오페이 연동을 통한 결제 기능 완비',
      'Celery → 주문 완료 후 재고 차감/이메일 알림 백그라운드 처리',
      '스케줄링 → 프로모션 쿠폰 자동 발급, 마감 시간 안내',
      '생성형 AI → 제품 설명 생성, 리뷰 요약 및 자동 응답',
      '채팅 → 고객센터 실시간 응답 서비스',
    ],
    descList2: [
      '전자상거래 백엔드에 필요한 주요 핵심 기능을 모두 구현했다는 점을 통해 특정 분야에 특화된 백엔드 개발자가 아닌 올라운더 백엔드 개발자라는 점을 어필할 수 있어요',
      '실무에 즉시 투입 가능한 수준의 쇼핑몰 시스템 구현력을 증명하여 백엔드 기술 스택을 단순 이론이 아닌 다양한 응용법까지 알고 있다는 점을 어필할 수 있어요.',
    ],
  },
  {
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section5_project3_m.gif',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section5_project3_pc.gif',
    type: '프로젝트 3',
    title: '지오펜싱 기반 데이터 연동 기술 개발',
    descList: [
      'Celery → 위치 변화에 따른 이벤트 발생 후 백그라운드 설명 생성 처리',
      '스케줄링 → 특정 시간대별 위치 이벤트 트리거 (예 : 퇴근길 푸시 알림)',
      '생성형 AI → 위치 기반 관광 안내 설명 생성',
      'Django + 위치 API → 실시간 위치 기반 사용자 관리',
      '채팅 → 도슨트 AI와 대화 기능',
    ],
    noti: '*실제 국민대학교 대상으로 진행된 기업 프로젝트',
    descList2: [
      'IoT/스마트시티 서비스로 확장 가능한 인프라를 통해 최신 기술 기반의 다양한 신규 비즈니스 영역까지 수행 가능하다는 점을 어필할 수 있어요.',
      '위치 기반 인텔리전스 구현 경험과 AI 실시간 연동 기반 자동화 서비스 구현 경험을 통해 기존의 서비스들을 최신 스킬들을 기반으로 고도화 시킬 수 있다는 점을 어필할 수 있어요.',
    ],
  },
]

export const projectDetailList = [
  {
    title: '부동산 거래 웹사이트 구축 프로젝트',
    descList: [
      '실시간 시세 분석 \n→ 초기에 더미 데이터 기반으로 크롤링 시물레이션 구현',
      '자동 리포트 생성 \n→ Celery Beat로 매일 DB의 매물 개수, 평균가 집계',
      '실시간 채팅 \n→ 1:1 채팅방 (로그인 한 유저끼리 메시지 주고 받기)',
      'AI FAQ 챗봇 \n→ OpenAI API로 간단한 Q&A 챗봇 구현',
      '매물 설명 생성 \n→ 매물 키워드 입력 > ChatGPT로 문장 생성하여 자동 저장',
    ],
  },
  {
    title: '쇼핑몰 플랫폼 개발 프로젝트',
    descList: [
      '결제 연동 \n→ Django+Stripe AI, Paypal AI 등을 통해 테스트 카드 결제 구현',
      '주문/재고 관리 \n→ 장바구니+주문 → 재고 수량 감소 로직 구현',
      '이메일 알림 \n→ 주문 후 Celery로 이메일 전송 (콘솔에서 확인 가능)',
      '프로모션 쿠폰 발급 \n→ 스케줄링으로 정해진 시간에 쿠폰 생성',
      '리뷰 자동 응답 \n→ 리뷰 입력 > ChatGPT가 자동 응답 댓글 생성',
      'AI 제품 설명 \n→ 제품 이미지 URL+설명 키워드 > \nChatGPT로 문장 생성',
    ],
  },
  {
    title: '지오펜싱 기반 데이터 연동 기술 개발',
    descList: [
      '위치 API \n-> 사용자가 위도/경도 입력시 > 현재 위치 출력',
      '특정 위치 도달시 안내 \n→ 조건(특정 좌표 반경) 만족시 알림 출력',
      '푸시 콘텐츠 생성 \n→ Celery로 ChatGPT 기반 안내 메시지 생성',
      '실시간 이동 패턴 분석 \n→ JSON 기반 더미 이동 경로 데이터 시각화',
      '도슨트 채팅 \n→ ChatGPT API 연동된 도슨트 질문 응답 봇 개발',
    ],
  },
]

export const projectOutputList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img1.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img1_thumbnail.png',
    title: 'Coldplay',
    desc: '프리랜서 매칭 플랫폼 개발',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img2.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img2_thumbnail.png',
    title: 'Fankick',
    desc: '스포츠 커뮤니티 플랫폼 개발',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img3.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img3_thumbnail.png',
    title: 'Gallery with me',
    desc: '미술대학 졸업작품 중개 플랫폼 개발',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img4.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img4_thumbnail.png',
    title: 'Gymvym',
    desc: '헬스장 커뮤니티 구축',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img5.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img5_thumbnail.png',
    title: 'Momento',
    desc: '여행지 추천 사이트 구축',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img6.mp4',
    thumbnail:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-16th/section6_img6_thumbnail.png',
    title: 'Wizmap',
    desc: '맛집 지도 사이트 구축',
  },
]

export const reviewList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-14th/section9_img2.png',
    title: '혼자 공부한다는 생각이 전혀 들지 않아요.',
    desc: '친절한 강사님과 도움을 주신 멘토분들께 너무 감사하다.',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-14th/section9_img5.png',
    title: '개발은 어려운 것이 아니라 재미있다는 것이라는 생각이 들었어요',
    desc: '개발이 참 재밌다는 걸 알게 되었습니다.',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-14th/section9_img6.png',
    title: '무엇 하나 부족한 점 없는 프로젝트 퀄리티',
    desc: '덕분에 좋은 프로젝트 경험을 쌓았습니다.',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-14th/section9_img4.png',
    title: '‘자신감’을 키울 수 있다는 점',
    desc: '백엔드 개발자로 성장하는 데 필요한 역량과 자신감을 키울 수 있는 뜻깊은 과정이었습니다. 모두들 수고 많으셨습니다!',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-14th/section9_img1.png',
    title: '실무 스킬을 경험할 수 있다는 점이 가장 큰 장점!',
    desc: '실무에서 쓰이는 플로우차트에 따라 프로젝트를 하는 경험이 필요했는데 그것을 할 수 있어서 너무 좋았다',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-backendp-14th/section9_img3.png',
    title: '이젠 확실한 저만의 로드맵이 생겼어요',
    desc: '아무것도 몰랐던 6개월 전에 내가 이제 앞으로 무엇을 해야 할지 방향을 잡아주었습니다. 열정적인 강사님, 멘토님, 매니저님 덕분에 많은 게 바뀌었습니다',
  },
]

export const benefitDetailList = [
  {
    title: '취업 방향성 탐색',
    descList: [
      '취업 준비 로드맵 특강',
      '개별 진로 탐색, 취업 로드맵 수립, 포트폴리오 작업 방향성 탐색',
    ],
  },
  {
    title: '취업 역량 강화',
    descList: [
      '이력서/자기소개서 작성 방법 특강 진행 (이력서 양식 및 대기업 합격 자기소개서 샘플 포함)',
      'IT 전문 취업 컨설턴트의 포트폴리오 꿀팁 대방출',
      '도메인 기반 취업 스터디 운영',
    ],
  },
  {
    title: '수료 후 지속 케어',
    descList: [
      '우수 수료생 대상 인턴십 기회 제공 및 채용 연계',
      '교육 과정 수료 이후에도 지속적인 구직활동 현황 체크',
      '스타트업 인사팀장 출신 코치의 1:1 상담 프로그램 지원',
      '수료 후 6개월간 이력서 및 포트폴리오 첨삭 제공',
      'IT 전직무 수료생이 모인 ”세렝게티“ 네트워크를 통한 스터디, 프로젝트, IT 취업정보 공유',
    ],
  },
]

export const firstCompanyList = [
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/yeogi_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/krafton_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/3dot3_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/linkagelab_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/payhere_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/opensg_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/lg_logo.png',
]

export const secondCompanyList = [
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/pengtai_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/knowhow_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/explatform_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/lisn_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/tmaxsoft_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/doodlin_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/moneylab_logo.png',
  'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/bizbee_logo.png',
]

export const benefitSlideList = [
  {
    title: '교육비 전액 무료',
    desc: '내일배움카드로 약 1,700만원 상당의 교육을 \n무료로 들을 수 있어요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img2.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img2_pc.png',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 81만 원의 훈련 지원금을 받을 수 있어요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img3.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img3_pc.png',
    option:
      '*단, 국민취업제도 참여 유형을 포함한 개인의 상황에 따라 다를 수 있으며 자세한 사항은 고용 24에서 확인해 주세요.',
  },
  {
    title: '교육 장비 지원',
    desc: '교육 시작 직후, 교육 장비가 필요한 인원에 \n한하여 무료로 장비를 대여해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img4.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img4_pc.png',
  },
  {
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행할 수 \n있는 오프라인 공간을 지원해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img5.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img5_pc.png',
  },
  {
    title: '교육에 필요한 참고 도서 지원',
    desc: '교육에 참여하는 모든 수강생에게 참고 도서를 \n무상으로 지원해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img1.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img1_pc.png',
  },
]

export const applySchedule1List = [
  {
    title: '모집 기간',
    content: '3월 28일(금) 오후 2시 ~ 04월 27일(일) 오후 11시',
  },
]

export const applySchedule2List = [
  {
    title: '합격자 발표일',
    content: '지원서 제출 후 7일 이내 결과 개별 안내 (영업일 기준)',
  },
]

export const eduScheduleList = [
  {
    title: 'OT&개강',
    content: '04월 30일(수) 오후 1시',
  },
  {
    title: '교육 기간',
    content: '2025년 04월 30일 \n~ 2025년 10월 28일',
  },
  {
    title: '교육 시간',
    content: '920시간 / 평일 9시 ~ 18시 \n(점심시간 12시 ~ 13시 제외)',
  },
  {
    title: '학습 형태',
    content: '실시간 온라인 교육',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. 발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. \n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 반드시 오프라인에서만 발급 받을 수 있나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다. \n자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 고용24 수강신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. \n안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 백엔드 개발자가 되려는 강한 의지와 계획만 있으시면 됩니다. \n다만, 합격 후 6개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복 지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
    {
      question: '[지원] 미성년자도 지원이 가능한가요?',
      answer:
        '미성년자도 지원은 가능하나 고용노동부 1350 또는 거주지 관할 고용센터를 통해 확인이 필요합니다.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 신청 → 1차 지원서(서류) 제출 → 최종합격자 발표 → 고용24 수강신청 순으로 진행됩니다. \n국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n*발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '현직 백엔드 개발자의 특강 및 면접 관련 프로그램을 지원합니다. 또한 최신 채용 트렌드를 반영한 전문적인 이력서 특강 및 피드백을 통한 취업 지원을 받으실 수 있습니다. \n*제공되는 프로그램 항목은 내부 사정에 의해 변경될 수 있습니다.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다. \n1. 고용24 앱 설치 후 QR코드 인증(개인 진행) \n2. 줌 모니터링을 통한 매시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정) \n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 4개월동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[특전 혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answer:
        '네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다. \n국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고 2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. \n다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
